import { useSetAtom } from 'jotai';
import { Button, Tooltip } from '@optiaxiom/react';
import { useDecision } from '@optimizely/react-sdk';

import opalAvatar from '@frontend/assets/opal.png';
import { opalOverlayOpenAtom } from '@frontend/atoms';
import { FeatureFlags } from '@frontend/constants';

import { opalIconStyle } from './OpalOverlayButton.css';

export function OpalOverlayButton() {
  const setIsOpen = useSetAtom(opalOverlayOpenAtom);
  const [decision] = useDecision(FeatureFlags.OPAL_CHAT_OVERLAY);

  if (!decision.enabled) return null;

  return (
    <Tooltip content="Open Opal Chat" delayDuration={0}>
      <Button
        appearance="subtle"
        icon={<img src={opalAvatar} alt="" width={28} height={28} className={opalIconStyle} />}
        size="lg"
        aria-label="Open Opal Chat"
        onClick={() => setIsOpen(v => !v)}
      >
        Ask Opal
      </Button>
    </Tooltip>
  );
}
